export default __webpack_public_path__ + "graphics/gotham.fb91a969.png";